import { LayoutRoute } from 'components/Layout';
import { LF } from 'containers/LineasFinancieras/Constantes/general';
import { LFCliente } from 'containers/LineasFinancieras/LFCliente';
import { LFDatosAsegurado } from 'containers/LineasFinancieras/LFDatosAsegurado';
import LFFinPago from 'containers/LineasFinancieras/LFFinPago';
import LFPago from 'containers/LineasFinancieras/LFPago';
import LFPlanes from 'containers/LineasFinancieras/LFPlanes';
import { LFPreguntas } from 'containers/LineasFinancieras/LFPreguntas';
import { LFResumen } from 'containers/LineasFinancieras/LFResumen';
import { LFVigencia } from 'containers/LineasFinancieras/LFVigencia';
import RecuperarCotizacionRCPA from 'containers/LineasFinancieras/RecuperarCotizacionRCPA';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import PrivateLayoutRoute from 'components/Layout/PrivateLayoutRoute';
import React from 'react';

const RCPA_ROUTES = [
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.datosAsegurado}`}
    layout={HomePublicaLayout}
    component={LFDatosAsegurado}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.preguntas}`}
    layout={HomePublicaLayout}
    component={LFPreguntas}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.planes}`}
    layout={HomePublicaLayout}
    component={LFPlanes}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.resumen}`}
    layout={HomePublicaLayout}
    component={LFResumen}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.cliente}`}
    layout={HomePublicaLayout}
    component={LFCliente}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.vigencia}`}
    layout={HomePublicaLayout}
    component={LFVigencia}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.pago}`}
    layout={HomePublicaLayout}
    component={LFPago}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    loginRequired={true}
    path={`${LF.urls.finPago}`}
    layout={HomePublicaLayout}
    component={LFFinPago}
    navBarTab="personas"
  />,
  <PrivateLayoutRoute
    exact={true}
    loginRequired={true}
    path="/recuperar-cotizacion-rcpa"
    layout={HomePublicaLayout}
    component={RecuperarCotizacionRCPA}
  />,
];

export default RCPA_ROUTES;
